import React from 'react';
import { Drawer as RapydDrawer } from '@rapyd/react-ui-library';
import { DrawerProps } from '@rapyd/react-ui-library/dist/components/Drawer';

interface IDrawerProps extends DrawerProps {}

const Drawer = ({ className, name, ...rest }: IDrawerProps) => {
  return <RapydDrawer className={className} name={name || 'drawer'} {...rest} />;
};

export default Drawer;
